const config = {
    filters: [
        {
            label: 'Featured',
            id: 'filter-group-featured'
        },
        {
            label: 'Price Range',
            id: 'filter-group-price-range'
        },
        {
            label: 'Pill Type',
            id: 'filter-group-pill-type'
        },
        {
            label: 'Rating',
            id: 'filter-group-rating'
        },
        {
            label: 'Count',
            id: 'filter-group-count'
        },
        {
            label: 'Benefits',
            id: 'filter-group-benefits'
        },
        {
            label: 'Ingredients',
            id: 'filter-group-ingredients'
        }
    ]
};

let has_subcollections = false;
if (document.querySelector('#SubCollectionProductGrid')) has_subcollections = true;

class CollectionFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = window.debounce((event) => {
            if (
                (event.target && event.target.classList.contains('filter-checkbox')) ||
                event.target.name == 'sort_by'
            ) {
                this.onSubmitHandler(event);
            }
        }, 500);

        this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
        window.addEventListener('popstate', this.onHistoryChange.bind(this));
        this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
            input.addEventListener('change', this.debouncedOnSubmit.bind(this));
        });

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', window.natureMade.onKeyUpEscape);

        if (has_subcollections) this.renderCollectionProductGrid2();

        this.addEventListener('click', (e) => {
            if (e.target && e.target.classList.contains('show-more-filter')) {
                const filterLi = e.target.closest('.filter-item-group').querySelectorAll('li');
                e.target
                    .closest('.filter-item-group')
                    .querySelector('.filter-items-wrapper')
                    .classList.remove('active');
                if (e.target.textContent == 'Show All') {
                    e.target.textContent = 'Show Less';
                    filterLi.forEach((item, i) => {
                        if (i > 5) item.style.display = 'list-item';
                    });
                } else {
                    e.target.textContent = 'Show All';
                    filterLi.forEach((item, i) => {
                        if (i > 5) item.style.display = '';
                    });
                }
            }

            if (
                (e.target && e.target.classList.contains('refinement-list-title')) ||
                e.target.closest('.refinement-list-title')
            ) {
                const facetWrapper = e.target.closest('.filter-item-group');
                if (facetWrapper.classList.contains('hide-facet')) {
                    facetWrapper.classList.remove('hide-facet');
                } else {
                    facetWrapper.classList.add('hide-facet');
                }
            }

            if (
                (e.target && e.target.classList.contains('facet-search-close-button')) ||
                e.target.closest('.facet-search-close-button')
            ) {
                const facetSearchWrapper = e.target.closest('.facet-search');
                const ulGroup = e.target.closest('.filter-item-group');
                const ul = ulGroup.querySelector('.filter-items-wrapper');
                const li = ul.querySelectorAll('li');
                facetSearchWrapper.querySelector('.facet-search-input').value = '';
                facetSearchWrapper.classList.remove('search-active');
                facetSearchWrapper.querySelector('.facet-no-results').style.display = '';
                ulGroup.querySelectorAll('.filter-item').forEach((item) => {
                    item.style.display = '';
                });
                li.forEach((li) => {
                    li.style.display = '';
                });
            }

            const loadMoreBtn = e.target.closest('.ais-InfiniteHits-loadMore');
            if (loadMoreBtn) {
                this.loadMoreProducts(e);
            }
        });
        this.intSortOnLoad();
    }

    /**
     * on load, the grid is rendered in order as the products are sorted by shopify
     * This function will reload the grid to re-order the products via js.
     * This only fires if the grid is sort-alphabetically, ATM
     */
    intSortOnLoad() {
        if (!this.dataset.sortByOnLoad || !this.dataset.sortByOnLoad.includes('title')) return;
        document.addEventListener('DOMContentLoaded', () => {
            const firstSortOption = document.querySelector('[name="sort_by"]');
            if (!firstSortOption) return;
            firstSortOption.dispatchEvent(new Event('change')); // dispatch change to force submit the form and reload the grid
        });
    }

    handleize(str) {
        str = str.toLowerCase();

        const toReplace = ['"', "'", '\\', '(', ')', '[', ']', '.'];
        for (var i = 0; i < toReplace.length; ++i) {
            str = str.replace(toReplace[i], '');
        }
        str = str.replace(/\./g, '').replace(/\W+/g, '-');
        if (str.charAt(str.length - 1) == '-') {
            str = str.replace(/-+\z/, '');
        }
        if (str.charAt(0) == '-') {
            str = str.replace(/\A-+/, '');
        }
        return str;
    }

    onSubmitHandler(event) {
        event.preventDefault();
        if (document.activeElement.id)
            window.lastFocusedRefinementOption = `#${document.activeElement.id}`;
        const formData = new FormData(event.target.closest('form'));
        const searchParams = new URLSearchParams(Array.from(formData.entries())).toString();
        this.renderPage(searchParams, event);
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        this.toggleActiveFacets();
        this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
    }

    onHistoryChange(event) {
        const searchParams = event.state ? event.state.searchParams : '';
        if (!searchParams) return;

        this.renderPage(searchParams, null, false);
    }

    toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    renderPage(searchParams, event, updateURLHash = true) {
        const countContainerDesktop = document.getElementById('CollectionProductCountDesktop');
        document.querySelectorAll('.collection').forEach((item) => {
            item.classList.add('loading');
        });
        document.querySelectorAll('.filter-item-group').forEach((item) => {
            item.classList.add('loading');
            item.setAttribute('inert', '');
        });
        if (document.getElementById('CollectionProductCount')) {
            document.getElementById('CollectionProductCount').classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        if (updateURLHash) this.updateURLHash(searchParams);

        if (has_subcollections) {
            this.renderCollectionProductGrid2();
        } else {
            this.renderCollectionProductGrid(searchParams, event);
        }
    }
    /** Renders the main collection product grid */
    renderCollectionProductGrid(searchParams, event) {
        const url = `${window.location.pathname}?${searchParams}`;
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                const activeFilterCount = Array.from(
                    parsedHTML.querySelectorAll('[type="checkbox"]:checked')
                ).length;
                const collectionItemsActiveCount = Array.from(
                    parsedHTML.querySelectorAll('.ais-InfiniteHits-item:not(.marketing-card)')
                ).length;
                this.renderFilters(parsedHTML, event, activeFilterCount);
                this.renderProductGrid(html);

                //render product results count
                const activeProductCountContainer = document.querySelector('[data-product-count]');
                if (activeProductCountContainer) {
                    activeProductCountContainer.innerHTML = `${
                        collectionItemsActiveCount > 0 && activeFilterCount > 0
                            ? `(${collectionItemsActiveCount})`
                            : ''
                    }`;
                }
            })
            .finally(() => {
                document.querySelectorAll('.btn-heart').forEach((element) => {
                    let favHandle = element.getAttribute('data-handle');
                    if (window.natureMade.wishlistArray.includes(favHandle)) {
                        element.classList.add('active');
                    }
                });
            });
    }

    /** render subcollections product grid */
    renderCollectionProductGrid2() {
        const searchParams = window.location.search || '';
        let promiseUrls = [];
        const collections = document.querySelectorAll('.collection-section:not(.hidden)');
        collections.forEach((collection, index) => {
            const collection_url = collection.dataset.url;
            promiseUrls.push(fetch(`${collection_url}${searchParams}`));
        });

        Promise.all(promiseUrls)
            .then((responses) => {
                return Promise.all(
                    responses.map(function (response) {
                        return response.text();
                    })
                );
            })
            .then((responseText) => {
                //render the products
                let filter_tabs_id_array = [];
                let filter_tabs_array = [];
                let collectionItemsActiveFilterCount = 0;
                let collectionItemsActiveCount = 0;
                responseText.forEach((data) => {
                    const html = new DOMParser().parseFromString(data, 'text/html');
                    const innerCollection = html.querySelector('.inner-collection');
                    if (innerCollection) {
                        const collectionId = innerCollection.dataset.id;
                        const collectionProductGrid = html.getElementById('CollectionProductGrid');
                        if (collectionProductGrid) {
                            const collectionContent = collectionProductGrid.querySelector(
                                `.inner-collection_${collectionId}`
                            );
                            if (collectionContent) {
                                let collectionItems = Array.from(
                                    collectionContent.querySelectorAll('.ais-InfiniteHits-item')
                                );
                                const productResultsCount = collectionContent.querySelectorAll(
                                    '.ais-InfiniteHits-item:not(.marketing-card)'
                                ).length;
                                collectionItemsActiveFilterCount =
                                    collectionItemsActiveFilterCount + productResultsCount;
                                collectionItemsActiveCount =
                                    collectionItemsActiveCount + productResultsCount;
                                this.renderProductGrid2(
                                    collectionId,
                                    collectionContent,
                                    collectionItems
                                );
                            }
                        }
                    }

                    const filterTabs = html.querySelectorAll('.checked-filter-tags .filter-tabs');
                    filterTabs.forEach((tab) => {
                        filter_tabs_array.push(tab);
                    });
                });

                //render no product results
                const subCollectionProductGrid = document.querySelector(
                    '#SubCollectionProductGrid'
                );
                const filterNoResults = document.querySelector('.filter-no-results');
                if (collectionItemsActiveFilterCount == 0) {
                    subCollectionProductGrid.style.display = 'none';
                    filterNoResults.style.display = 'block';
                } else {
                    subCollectionProductGrid.style.display = '';
                    filterNoResults.style.display = 'none';
                }

                //render the filters
                this.renderFilters2(responseText);

                //render active filter tabs
                let filter_tabs_html = '';
                filter_tabs_array.forEach((tab) => {
                    const id = tab.id;
                    if (!filter_tabs_id_array.includes(id)) {
                        filter_tabs_id_array.push(id);
                        filter_tabs_html += tab.outerHTML;
                    }
                });
                document.querySelector('.checked-filter-tags').innerHTML = filter_tabs_html;

                const filter_count = filter_tabs_id_array.length;

                //render product results count
                const activeProductCountContainer = document.querySelector('[data-product-count]');
                if (activeProductCountContainer) {
                    activeProductCountContainer.innerHTML = `${
                        collectionItemsActiveCount > 0 && filter_count > 0
                            ? `(${collectionItemsActiveCount})`
                            : ''
                    }`;
                }

                //render clear filter
                const clear_filter_button = document.querySelector('.clear-filters');
                const sort_by_value = document.querySelector(
                    'input[name="sort_by"]:checked'
                )?.value;
                clear_filter_button.querySelector('a').href =
                    `${window.location.pathname}?sort_by=${sort_by_value}`;
                const product_grid_wrapper = document.querySelector('#CollectionProductGrid');
                if (filter_count > 0) {
                    clear_filter_button.classList.remove('hide');
                    product_grid_wrapper.classList.add('filter-active');
                } else {
                    clear_filter_button.classList.add('hide');
                    product_grid_wrapper.classList.remove('filter-active');
                }
            })
            .finally(() => {
                document.querySelectorAll('.btn-heart').forEach((element) => {
                    let favHandle = element.getAttribute('data-handle');
                    if (window.natureMade.wishlistArray.includes(favHandle)) {
                        element.classList.add('active');
                    }
                });
                document.body.classList.add('collection-products-loaded');
            });
    }

    removeLoadingOverlay() {
        this.querySelectorAll('.collection.loading').forEach((container) => {
            container.classList.remove('loading');
        });
    }

    /**
     * sorts products alphabetically
     * @param {html} container
     * @param {string} sortOption_AZ can be title-ascending || title-descending
     * @returns
     */
    sortAlphabeticallyByShortTitleAndTagline(
        container,
        sortOption_AZ,
        marketingCardOverride = null
    ) {
        const list = container.querySelector('.ais-InfiniteHits-list');
        const marketingCard = list.querySelector('.ais-InfiniteHits-item.marketing-card');
        if (!list) throw new Error('product list not found');

        // Exclude marketing card from being sorted
        const listItems = Array.from(
            list.querySelectorAll('.ais-InfiniteHits-item:not(.marketing-card)')
        );
        listItems.sort((prevItem, nextItem) =>
            prevItem.querySelector('[data-title-tagline]')?.dataset.titleTagline.trim() >
            nextItem.querySelector('[data-title-tagline]')?.dataset.titleTagline.trim()
                ? 1
                : -1
        );

        if (sortOption_AZ.includes('descending')) listItems.reverse();

        list.innerHTML = '';
        listItems.forEach((item) => {
            list.appendChild(item);
        });

        const productListContainer = document.querySelector(`#${container.id}`);
        if (marketingCard && productListContainer) {
            const initCardCountLimit = productListContainer.dataset.desktopAmount
                ? parseInt(productListContainer.dataset.desktopAmount)
                : null;
            if (
                productListContainer.classList.contains('marketing-card-bottom') &&
                initCardCountLimit &&
                listItems.length + 1 > initCardCountLimit
            ) {
                const lastItem = list.querySelectorAll(
                    '.ais-InfiniteHits-item:not(.marketing-card)'
                )[initCardCountLimit - 1];
                if (lastItem) list.insertBefore(marketingCard, lastItem);
            } else {
                /**
                 * Check if "enhanced" template is applied.
                 * If not, maintain the marketing card's position
                 */
                if (productListContainer.classList.contains('marketing-card-bottom')) {
                    list.appendChild(marketingCard);
                } else {
                    if (marketingCardOverride) {
                        const mcPosition = marketingCardOverride.position - 1;
                        const positionReferenceNode = list.children[mcPosition];
                        list.insertBefore(marketingCard, positionReferenceNode);
                    } else {
                        list.prepend(marketingCard);
                    }
                }
            }
        }

        return container;
    }

    getSelected_AZ_SortOption() {
        const selectedOption = document.querySelector('input[name="sort_by"]:checked')?.value;
        if (!selectedOption) return;
        return selectedOption.includes('title') ? selectedOption : '';
    }

    renderProductGrid(html) {
        const currentGrid = document.getElementById('CollectionProductGrid');
        if (!currentGrid) return;

        const newGrid = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('CollectionProductGrid');

        repositionMarketingCardOnMobile();

        const sortOption_AZ = this.getSelected_AZ_SortOption();
        if (!sortOption_AZ) {
            currentGrid.innerHTML = newGrid.innerHTML;
            return;
        }

        // manually sort alphabetically by the short-title + tagline
        currentGrid.innerHTML = this.sortAlphabeticallyByShortTitleAndTagline(
            newGrid,
            sortOption_AZ
        ).innerHTML;

        this.removeLoadingOverlay();
    }

    renderProductGrid2(collectionId, collectionContent, collectionItems) {
        if (!collectionId || !collectionContent || !collectionItems) return;
        const collectionContainerWrapper = document.querySelector(
            `#collection-section-${collectionId}:not(.hidden)`
        );
        if (!collectionContainerWrapper) return;
        const collectionContainer = collectionContainerWrapper.querySelector(
            `.inner-collection_${collectionId}`
        );
        if (!collectionContainer) return;
        const anchorSpot = collectionContainerWrapper.querySelector('.anchor-spot');

        if (collectionItems.length == 0) {
            collectionContainerWrapper.style.display = 'none';
            this.hideJumpLink(anchorSpot);
        } else {
            if (anchorSpot) {
                const jumpLink = document.querySelector(
                    `[href='#${anchorSpot.id}'].button-jump-link`
                );
                if (jumpLink) {
                    jumpLink.style.display = '';
                }
            }

            /* remove marketing card */
            let marketingCard = collectionContent.querySelector(
                '.ais-InfiniteHits-item.marketing-card'
            );

            const marketingCardOverride = window[`marketingCardOverride_${collectionId}`];

            if (
                (collectionContainer.classList.contains('disabled-marketing-card') &&
                    marketingCard) ||
                (marketingCardOverride && marketingCard)
            ) {
                marketingCard.remove();
            }

            if (marketingCardOverride) {
                marketingCard = document.createElement('li');
                marketingCard.className = `ais-InfiniteHits-item marketing-card ${marketingCardOverride.full_bleed ? '' : 'non-full-bleed'}`;
                marketingCard.innerHTML = marketingCardOverride.html;
            }

            /* Enhanced template: reposition the marketing card */
            const collectionItemsContainer =
                collectionContent.querySelector('.ais-InfiniteHits-list');
            if (
                !collectionContainer.classList.contains('disabled-marketing-card') &&
                collectionItemsContainer &&
                collectionContainer.classList.contains('marketing-card-bottom') &&
                marketingCard
            ) {
                const initCardCountLimit = collectionContainer.dataset.desktopAmount
                    ? parseInt(collectionContainer.dataset.desktopAmount)
                    : null;
                if (initCardCountLimit && collectionItems.length > initCardCountLimit) {
                    const lastItem = collectionContent.querySelectorAll(
                        '.ais-InfiniteHits-item:not(.marketing-card)'
                    )[initCardCountLimit - 1];
                    if (lastItem) collectionItemsContainer.insertBefore(marketingCard, lastItem);
                } else {
                    collectionItemsContainer.appendChild(marketingCard);
                }
            } else if (marketingCardOverride) {
                /* dynamically insert the marketing card override into its designated position */
                const mcPosition = marketingCardOverride.position - 1;
                const positionReferenceNode = collectionItemsContainer.children[mcPosition];
                collectionItemsContainer.insertBefore(marketingCard, positionReferenceNode);
            }

            collectionContainerWrapper.style.display = '';
            const sortOption_AZ = this.getSelected_AZ_SortOption();
            if (!sortOption_AZ) {
                collectionContainer.innerHTML = collectionContent.innerHTML;
                renderViewMore(collectionContainer);
            } else {
                // manually sort alphabetically by the short-title + tagline
                collectionContainer.innerHTML = this.sortAlphabeticallyByShortTitleAndTagline(
                    collectionContent,
                    sortOption_AZ,
                    marketingCardOverride
                ).innerHTML;

                renderViewMore(collectionContainer);
                this.removeLoadingOverlay();
            }

            repositionMarketingCardOnMobile();
        }

        //update favorites return to page url
        if (!window.customerData) {
            const favoritesHearts = document.querySelectorAll('#CollectionProductGrid .btn-heart');
            const urlPath = window.location.pathname;
            favoritesHearts.forEach((item) => {
                item.setAttribute('data-href', `/account/register?return_url=${urlPath}&favorites`);
            });
        }
    }

    hideJumpLink(anchorSpot) {
        if (!anchorSpot) return;
        const jumpLink = document.querySelector(`[href='#${anchorSpot.id}'].button-jump-link`);
        if (!jumpLink) return;

        jumpLink.style.display = 'none';
    }

    renderProductCount(html) {
        const count = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('CollectionProductCount').innerHTML;
        const container = document.getElementById('CollectionProductCount');
        const containerDesktop = document.getElementById('CollectionProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
    }

    renderFilters(parsedHTML, event, activeFilterCount) {
        if (!parsedHTML) return;
        const facetDetailsElements = parsedHTML.querySelectorAll(
            '#CollectionFiltersForm .js-filter'
        );
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter(
            (element) => !matchesIndex(element)
        );
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        document.querySelectorAll('[data-filter-count]').forEach((item) => {
            if (
                item.closest('.products-list-filters-title') ||
                item.closest('.product-list-filter-actions')
            ) {
                item.innerHTML = activeFilterCount > 0 ? `(${activeFilterCount})` : '';
            } else {
                item.innerHTML =
                    activeFilterCount > 0
                        ? `<span class="filter-count">${activeFilterCount}</span>`
                        : '';
            }
        });

        facetsToRender.forEach((element) => {
            const hiddenFacet = element.dataset.hiddenFacet;
            const filterIndex = `.js-filter[data-index="${element.dataset.index}"]`;
            document.querySelector(filterIndex).innerHTML = element.innerHTML;
            document.querySelector(filterIndex).setAttribute('data-hidden-facet', hiddenFacet);
        });

        if (countsToRender) {
            const checkedFilterCount = Array.from(
                countsToRender.querySelectorAll('[type="checkbox"]:checked')
            ).length;
            const checkedFilterID = countsToRender.id;
            if (checkedFilterCount > 0) {
                document.getElementById(checkedFilterID).classList.add('active-facet');
            } else {
                document.getElementById(checkedFilterID).classList.remove('active-facet');
            }
        } else {
            document.querySelectorAll('.filter-item-group').forEach((item) => {
                item.classList.remove('active-facet');
            });
        }

        document.querySelectorAll('.filter-item-group').forEach((item) => {
            item.classList.remove('loading');
            item.removeAttribute('inert');
        });

        this.renderActiveFacets(parsedHTML);

        if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));

        document.querySelector(window.lastFocusedRefinementOption)?.focus();
    }

    renderFilters2(html_list) {
        let filter_group_html = '';
        const filter_container = document.querySelector('#FacetsWrapperDesktop');
        let activeFilters = 0;
        config.filters.forEach((filter, index) => {
            let filter_item_html = '';
            let filter_item_array = [];
            const filter_label = filter.label;
            let keep_facet_open = document
                .querySelector(`#${filter.id}`)
                ?.classList?.contains('active-facet')
                ? true
                : false;

            html_list.forEach((data) => {
                const html = new DOMParser().parseFromString(data, 'text/html');
                const fetched_filter_array = html.querySelectorAll(`#${filter.id} .filter-item`);
                fetched_filter_array.forEach((filter) => {
                    const filter_input = filter.querySelector('input');
                    const value = filter_input.value;
                    const count = filter_input.dataset.count;
                    const id = filter.id;
                    const filter_checked = filter_input.dataset.checked;
                    const filterData = {
                        id: id,
                        value: value,
                        count: parseInt(count),
                        html: filter,
                        checked: filter_checked
                    };
                    if (
                        !filter_item_array.filter((e) => {
                            return e.value === value;
                        }).length
                    ) {
                        filter_item_array.push(filterData);
                    } else {
                        const index = filter_item_array.findIndex((object) => {
                            return object.id === id;
                        });
                        if (index !== -1) {
                            filter_item_array[index].count =
                                filter_item_array[index].count + parseInt(count);
                        }
                    }
                });
            });

            //sort by result count
            if (filter_label != 'Count') {
                filter_item_array.sort((a, b) => {
                    if (a.value < b.value) {
                        return -1;
                    }
                    if (a.value > b.value) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                filter_item_array.sort((a, b) => {
                    return parseInt(a.value) - parseInt(b.value);
                });
            }

            let filterSectionActive = false;
            if (filter_label == 'Rating') {
                filter_item_array.reverse();
            }

            let filterSearchValue = '';
            if (filter_label == 'Benefits' || filter_label == 'Ingredients') {
                const filterSearchInput = document.querySelector(
                    `.facet-search-input__${this.handleize(filter_label)}`
                );
                filterSearchValue = filterSearchInput ? filterSearchInput.value : '';
            }
            filter_item_array.forEach((filter, i) => {
                const filterHTML = filter.html.innerHTML;
                const filterCount = filter.count;
                const filterChecked = filter.checked;
                if (filterChecked == 'true') {
                    filterSectionActive = true;
                }
                if (filterCount > 0) {
                    activeFilters = filterChecked == 'true' ? activeFilters + 1 : activeFilters;
                    let filterLiStyle = '';
                    if (filter_label == 'Benefits' || filter_label == 'Ingredients') {
                        const filterValueUpcase = filter.value.toLowerCase();
                        if (
                            filterSearchValue != '' &&
                            filterValueUpcase.indexOf(filterSearchValue.toLowerCase()) === -1
                        ) {
                            filterLiStyle = 'display: none';
                        }
                    }
                    filter_item_html += `<li class="filter-item" id="${filter.id}" style="${filterLiStyle}">${filterHTML}</li>`;
                }
            });

            const filterSearchHTML = `
          <div class="facet-search ${filterSearchValue != '' ? 'search-active' : ''}">
            <div class="field">
              <input type="text" placeholder="Search ${filter_label}" class="facet-search-input facet-search-input__${this.handleize(
                  filter_label
              )}" value="${filterSearchValue}" onkeyup="searchFacets(this)">
              <button class="search_close_button facet-search-close-button field__button" aria-label="close" type="button">
                <svg class="icon icon-close">
                  <use href="#icon-close"></use>
                </svg>
              </button>
              <button type="button" class="facet-search-button field__button" aria-label="Search">
                <svg class="icon icon-search">
                  <use href="#icon-search"></use>
                </svg>
              </button>
            </div>
            <p class="facet-no-results">No results</p>
          </div>
        `;

            filter_group_html += `
          <div class="filter-item-group js-filter ${!filter_item_array.length ? 'hide' : ''} ${
              filterSectionActive ? 'active-facet' : ''
          } ${index != 0 && !filterSectionActive && !keep_facet_open ? 'hide-facet' : ''}" data-index="${index + 1}" id="filter-group-${this.handleize(filter_label)}">
            <div class="loading-overlay gradient"></div>
            <button type="button" class="refinement-list-title h5">
              <span class="refinement-title-text">${filter.label}</span>
              <svg class="icon-caret" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true" focusable="false" role="presentation">
                <use href="#icon-caret">
              </svg>
            </button>
            <div class="facets__display-vertical">
              ${filter_label == 'Benefits' || filter_label == 'Ingredients' ? filterSearchHTML : ''}
              <ul class="filter-items-wrapper ${
                  filterSectionActive ? 'active' : ''
              }" role="list">${filter_item_html}</ul>
            </div>
          </div>
        `;
        });
        filter_container.innerHTML = filter_group_html;
        //render filter count
        document.querySelectorAll('[data-filter-count]').forEach((item) => {
            if (
                item.closest('.products-list-filters-title') ||
                item.closest('.product-list-filter-actions')
            ) {
                item.innerHTML = activeFilters > 0 ? `(${activeFilters})` : '';
            } else {
                item.innerHTML =
                    activeFilters > 0 ? `<span class="filter-count">${activeFilters}</span>` : '';
            }
        });

        document.querySelectorAll('.filter-item-group').forEach((item) => {
            item.classList.remove('loading');
            item.removeAttribute('inert');
        });

        document.querySelector(window.lastFocusedRefinementOption)?.focus();
    }

    renderActiveFacets(html) {
        const activeFacetElementSelectors = [
            '.active-facets-mobile',
            '.active-facets-desktop',
            '.filter-by-product-wrapper'
        ];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        this.toggleActiveFacets(false);
    }

    renderAdditionalElements(html) {
        const mobileElementSelectors = [
            '.mobile-facets__open',
            '.mobile-facets__count',
            '.sorting'
        ];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('CollectionFiltersFormMobile').closest('menu-drawer').bindEvents();
    }

    renderCounts(source, target) {
        const countElementSelectors = ['.count-bubble', '.facets__selected'];
        countElementSelectors.forEach((selector) => {
            const targetElement = target.querySelector(selector);
            const sourceElement = source.querySelector(selector);

            if (sourceElement && targetElement) {
                target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
            }
        });
    }

    updateURLHash(searchParams) {
        history.pushState(
            {searchParams},
            '',
            `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
        );
    }

    getSections() {
        return [
            {
                id: 'main-collection-product-grid',
                section: document.getElementById('main-collection-product-grid').dataset.id
            }
        ];
    }

    loadMoreProducts(e) {
        const innerCollectionWrapper = e.target.closest('.inner-collection');
        const repositionMarketingCard =
            innerCollectionWrapper.classList.contains('marketing-card-bottom');
        const collectionCardsOrientation = innerCollectionWrapper.querySelector(
            '.collection-cards-orientation'
        );
        if (!innerCollectionWrapper || !collectionCardsOrientation) return;
        const amountToShowDesktop = innerCollectionWrapper.dataset.desktopAmount;
        const amountToShowMobile = innerCollectionWrapper.dataset.mobileAmount;
        if (!amountToShowDesktop || !amountToShowMobile) return;
        const amountToShow =
            window.innerWidth <= 749 ? parseInt(amountToShowMobile) : parseInt(amountToShowDesktop);
        const listWrapper = e.target.closest('.ais-InfiniteHits');
        const productList = listWrapper.querySelectorAll('.ais-InfiniteHits-item');
        const showMoreButton = listWrapper.querySelector('.ais-InfiniteHits-loadMore');
        const gradientOverlay = listWrapper.querySelector('div.container-has-cards-hidden');
        let hiddenProducts = getHiddenProducts(productList);
        if (repositionMarketingCard) {
            hiddenProducts = hiddenProducts.filter(
                (item) => !item.classList.contains('marketing-card')
            );
        }
        hiddenProducts.slice(0, amountToShow).forEach((item) => {
            item.style.display = 'block';
        });
        const hiddenProductsLeft = getHiddenProducts(
            repositionMarketingCard
                ? e.target
                      .closest('.ais-InfiniteHits')
                      .querySelectorAll('.ais-InfiniteHits-item:not(.marketing-card)')
                : e.target.closest('.ais-InfiniteHits').querySelectorAll('.ais-InfiniteHits-item')
        );
        if (!hiddenProductsLeft.length) {
            if (gradientOverlay) {
                gradientOverlay.style.display = 'none';
                gradientOverlay.classList.remove('active');
            }
            if (showMoreButton) {
                showMoreButton.style.display = 'none';
                showMoreButton.classList.remove('active');
            }
        }
    }
}

customElements.define('collection-filters-form', CollectionFiltersForm);

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) =>
            element.addEventListener('change', this.onRangeChange.bind(this))
        );

        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        this.querySelector('a').addEventListener('click', (event) => {
            event.preventDefault();
            const form =
                this.closest('collection-filters-form') ||
                document.querySelector('collection-filters-form');
            form.onActiveFilterClick(event);
            window.lastFocusedRefinementOption = `a.text-link[data-clear-filters]`;
        });
    }
}

customElements.define('facet-remove', FacetRemove);

const getHiddenProducts = (items) => {
    return Array.from(items).filter(
        (element) => window.getComputedStyle(element).display === 'none'
    );
};

const prodPerPageThreshold = 749;
let lastWidth = window.innerWidth;

const handleResize = () => {
    const currentWidth = window.innerWidth;
    if (
        (lastWidth <= prodPerPageThreshold && currentWidth > prodPerPageThreshold) ||
        (lastWidth > prodPerPageThreshold && currentWidth <= prodPerPageThreshold)
    ) {
        resetProductsPerPage();
        /**
         * Reset the "View More" to display or hide on resize event
         */
        document
            .querySelectorAll('[data-has-sub-collections] .inner-collection')
            .forEach((collection) => {
                renderViewMore(collection);
            });

        /**
         * Enhanced template: remove "View More"
         */
        repositionMarketingCardOnMobile();
    }
    lastWidth = currentWidth;
};

const resetProductsPerPage = () => {
    document
        .querySelectorAll(
            '.inner-collection .ais-InfiniteHits-item, .inner-collection .container-has-cards-hidden, .inner-collection .ais-InfiniteHits-loadMore'
        )
        .forEach((item) => (item.style.display = ''));
};

const renderViewMore = (content) => {
    const filteredItemsCount = content.querySelectorAll('.ais-InfiniteHits-item').length;
    if (!filteredItemsCount) return;
    const viewMoreBtn = content.querySelector('.ais-InfiniteHits-loadMore');
    const viewMoreGradient = content.querySelector('.container-has-cards-hidden');
    const collectionCardsOrientation = content.querySelector('.collection-cards-orientation');
    const amountToShowDesktop = content.dataset.desktopAmount;
    const amountToShowMobile = content.dataset.mobileAmount;

    if (
        !viewMoreBtn ||
        !viewMoreGradient ||
        !collectionCardsOrientation ||
        !amountToShowDesktop ||
        !amountToShowMobile
    )
        return;

    const amountToShow =
        window.innerWidth <= 749 ? parseInt(amountToShowMobile) : parseInt(amountToShowDesktop);
    viewMoreGradient.classList.remove('hide', 'active');
    viewMoreBtn.classList.remove('hide', 'active');
    if (viewMoreGradient.style.display == 'none' && viewMoreBtn.style.display == 'none') return;
    const viewMoreBtnClass = filteredItemsCount <= amountToShow ? 'hide' : 'active';
    const viewMoreGradientClass = filteredItemsCount <= amountToShow ? 'hide' : 'active';
    viewMoreGradient.classList.add(viewMoreGradientClass);
    viewMoreBtn.classList.add(viewMoreBtnClass);
};

const repositionMarketingCardOnMobile = () => {
    if (!document.querySelector('.enhanced-plp') || window.innerWidth > 749) return;

    document.querySelectorAll('.inner-collection').forEach((item) => {
        const marketingCard = item.querySelector('.marketing-card');
        const productListContainer = item.querySelector('.ais-InfiniteHits-list');
        const amountToShowMobile = item.dataset.mobileAmount;
        const cardsOrientation = item.querySelector('.collection-cards-orientation');
        if (
            item.classList.contains('disabled-marketing-card') ||
            !marketingCard ||
            !productListContainer ||
            !amountToShowMobile ||
            !cardsOrientation
        )
            return;
        const index = Array.prototype.indexOf.call(productListContainer.children, marketingCard);
        if (index <= amountToShowMobile) {
            const numberOfSiblings = amountToShowMobile - index;
            let currentCard = marketingCard;
            let count = 0;

            while (currentCard && count < numberOfSiblings) {
                currentCard = currentCard.nextElementSibling;
                if (currentCard) {
                    currentCard.style.display = 'block';
                    count++;
                }
            }
        }
        const hiddenProductsLeft = getHiddenProducts(
            productListContainer.querySelectorAll('.ais-InfiniteHits-item:not(.marketing-card)')
        );
        const overlay = item.querySelector('.container-has-cards-hidden');
        const viewMore = item.querySelector('.ais-InfiniteHits-loadMore');
        if (!overlay || !viewMore || hiddenProductsLeft.length) return;
        overlay.classList.remove('active');
        overlay.style.display = 'none';
        viewMore.classList.remove('active');
        viewMore.style.display = 'none';
    });
};

window.addEventListener(
    'resize',
    window.debounce(() => {
        handleResize();
    }, 300)
);

const searchFacets = (input) => {
    const filter = input.value.toUpperCase();
    const searchWrapper = input.closest('.facet-search');
    const ulGroup = input.closest('.filter-item-group');
    const ul = ulGroup.querySelector('.filter-items-wrapper');
    const li = ul.querySelectorAll('li');
    const noResultsMsg = searchWrapper.querySelector('.facet-no-results');
    let searchResultCount = 0;
    li.forEach((li) => {
        const facet = li.querySelector('input');
        const txtValue = facet.value;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li.style.display = 'list-item';
            searchResultCount = searchResultCount + 1;
        } else {
            li.style.display = 'none';
        }
    });
    if (filter != '') {
        searchWrapper.classList.add('search-active');
    } else {
        searchWrapper.classList.remove('search-active');
        li.forEach((li) => {
            li.style.display = '';
        });
    }
    if (searchResultCount > 0) {
        noResultsMsg.style.display = 'none';
    } else {
        noResultsMsg.style.display = 'block';
    }
};

document.querySelectorAll('input[name="sort_by"]').forEach((option) => {
    option.addEventListener('change', (e) => {
        if (!e.target.checked) return;

        const textValue = e.target.parentElement.querySelector('label')?.textContent;
        const activeSort = document.querySelector('[data-active-sort]');
        if (!textValue || !activeSort) return;

        activeSort.textContent = textValue;
    });
});
